import React, { useMemo } from "react";
import { translateText } from "../../../../shared/utils/historyTranslation";

const DONUT_RADIUS = 42;
const DONUT_CIRCUMFERENCE = 2 * Math.PI * DONUT_RADIUS;

export default React.memo(function SummaryV3Distribution({ distribution, total, translate }) {
  const t = (key, fallback) => translateText(translate, key, fallback);
  const chartTotal = distribution.total ?? total;
  const centerLabel = distribution.generatorProblems
    ? t("summary_v3_total_states", "Total estados")
    : t("summary_v3_total_cages", "Total jaulas");
  const rows = useMemo(
    () => [
      { label: t("summary_v3_legend_normal", "Normal"), value: distribution.normal, tone: "normal", color: "rgb(35, 64, 96)" },
      { label: t("summary_v3_legend_injecting", "Inyectando"), value: distribution.injecting, tone: "injecting", color: "#22c55e" },
      { label: t("summary_v3_legend_manual", "Manual"), value: distribution.manual, tone: "manual", color: "#4b4b52" },
      { label: t("summary_v3_legend_no_injection", "Sin Inyeccion"), value: distribution.warning, tone: "warning", color: "#f59e0b" },
      { label: t("summary_v3_legend_problems", "Problemas"), value: distribution.problem, tone: "problem", color: "#ef4444" },
    ],
    [distribution, translate]
  );
  const segments = useMemo(() => {
    if (!chartTotal) return [];
    let offset = 0;
    return rows
      .filter((row) => row.value > 0)
      .map((row) => {
        const length = (row.value / chartTotal) * DONUT_CIRCUMFERENCE;
        const segment = {
          ...row,
          dasharray: `${length} ${DONUT_CIRCUMFERENCE - length}`,
          dashoffset: -offset,
        };
        offset += length;
        return segment;
      });
  }, [rows, chartTotal]);

  return (
    <section className="summary-v3__distribution">
      <div className="summary-v3__panelHead">
        <h3>{t("summary_v3_distribution_title", "Distribucion general")}</h3>
      </div>
      <div className="summary-v3__distributionBody">
        <div className="summary-v3__donut">
          <svg className="summary-v3__donutChart" viewBox="0 0 100 100" aria-hidden="true">
            <circle className="summary-v3__donutTrack" cx="50" cy="50" r={DONUT_RADIUS} />
            {segments.map((segment) => (
              <circle
                key={segment.label}
                className="summary-v3__donutSegment"
                cx="50"
                cy="50"
                r={DONUT_RADIUS}
                stroke={segment.color}
                strokeDasharray={segment.dasharray}
                strokeDashoffset={segment.dashoffset}
              />
            ))}
          </svg>
          <div>
            <strong>{chartTotal}</strong>
            <span>{centerLabel}</span>
          </div>
        </div>
        <div className="summary-v3__distributionRows">
          {rows.map((row) => (
            <div key={row.label}>
              <span><i className={`summary-v3__legendDot summary-v3__legendDot--${row.tone}`} />{row.label}</span>
              <strong>{row.value} ({chartTotal ? Math.round((row.value / chartTotal) * 100) : 0}%)</strong>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
});
